import { render, staticRenderFns } from "./dispose.vue?vue&type=template&id=5a0d66dc&scoped=true&"
import script from "./dispose.vue?vue&type=script&lang=js&"
export * from "./dispose.vue?vue&type=script&lang=js&"
import style0 from "./dispose.vue?vue&type=style&index=0&id=5a0d66dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d66dc",
  null
  
)

export default component.exports